import axios from "axios";
import store from "../store/index";
import {
  USER_TOKEN,
  PARAMS,
  LANGUAGE,
  CURRENT_PUBLISHER_ID,
} from "../store/mutation-types";
import { initServerError } from "../utils/error";

export const baseURL = `${process.env.APPHI_ENDPOINT}api/v1`;
export const timeout = 25000;
const service = axios.create({
  baseURL: baseURL,
  timeout, // 请求超时时间
});
// 通用请求拦截器
service.interceptors.request.use(
  (config) => {
    // 如果是通过app跳转自动在头部加上必要日志参数
    const headerParams = store.getters[PARAMS];
    let language = store.getters[LANGUAGE];
    if (store.getters[PARAMS]) {
      config.headers["x-apphi-advertising-id"] = headerParams.advertisingId;
      config.headers["x-apphi-limit-ad-tracking"] =
        headerParams.limitAdTracking;
      config.headers["x-apphi-appsflyer-id"] = headerParams.appsFlyerId;
      config.headers["x-apphi-firebase-version"] = headerParams.fireBaseVersion;
      config.headers["x-apphi-useragent"] = headerParams.userAgent;
    }
    config.headers["X-Apphi-Accept-Language"] = language;
    // config.headers['Accept-Language'] = language
    const publisherId = store.getters[CURRENT_PUBLISHER_ID];
    if (publisherId) {
      config.headers["X-Apphi-Request-Publisher-Id"] = publisherId;
    }
    if (!config.ignoreToken) {
      config.headers.Authorization = store.getters[USER_TOKEN];
    }
    // 每次请求统一显示Loading 但是某些接口忽略loading显示
    return config;
  },
  function (error) {
    // eslint-disable-next-line
    console.error("请求发生错误");
    return Promise.reject(error);
  }
);
// 通用响应拦截器
service.interceptors.response.use(
  (response) => {
    // 统一获取响应头中地理位置信息并更新到store中
    console.log("response", response);
    return response;
  },
  function (error) {
    console.error("响应发生错误", error);
    return Promise.reject(initServerError(error));
  }
);
export default service;



// WEBPACK FOOTER //
// ./src/utils/fetch.js